var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgPlayButton = function SvgPlayButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 23.098 16.75 30.46c-2 1.155-4.5-.288-4.5-2.598V13.14c0-2.31 2.5-3.753 4.5-2.598L29.5 17.9c2 1.156 2 4.042 0 5.197Z",
    stroke: "#00FACD",
    strokeWidth: 2
  })));
};
var Memo = /*#__PURE__*/memo(SvgPlayButton);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI5LjUgMjMuMDk4MUwxNi43NSAzMC40NTkzQzE0Ljc1IDMxLjYxNCAxMi4yNSAzMC4xNzA2IDEyLjI1IDI3Ljg2MTJWMTMuMTM4OEMxMi4yNSAxMC44Mjk0IDE0Ljc1IDkuMzg2MDEgMTYuNzUgMTAuNTQwN0wyOS41IDE3LjkwMTlDMzEuNSAxOS4wNTY2IDMxLjUgMjEuOTQzNCAyOS41IDIzLjA5ODFaIiBzdHJva2U9IiMwMEZBQ0QiIHN0cm9rZS13aWR0aD0iMiIvPgo8L3N2Zz4K";